import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1916143_a63ugdsuije.js',
});

export default FontIcon;